import { useRouteLoaderData } from "react-router";
import { AccordionRoot } from "../../components/Accordion";
import { useStamdataPerson } from "../../hooks/stamdata/useStamdataPerson";
import { HomeLoaderResponse } from "../../interfaces/loaders";
import AccountBasis from "../../components/account/AccountBasis";
import AccountInteresser from "../../components/account/AccountInteresser";
// import AccountNytJob from "../../components/account/AccountNytJob";
import AccountDelegation from "../../components/account/AccountDelegation";
import ProfilIkkeKlarBesked from "../../components/ProfilIkkeKlarBesked";
import IkkePersonligSessionBesked from "../../components/IkkePersonligSessionBesked";
import { ROUTES } from "../../constants/routes";
import { getPersonligSideAfvisning } from "../../lib/personligSession";

export default function Account() {
  const loaderdata = useRouteLoaderData(
    ROUTES.homeIndex.id,
  ) as HomeLoaderResponse;

  // Friskt og ikke fra loader-data: loaderen genkøres ikke ved klientnavigation, så en profil, der
  // blev klar midt i en session, ville ellers blive ved med at melde "ikke klar" til næste egentlige
  // sideindlæsning — og en indsendt stamdataændring ville tilsvarende ikke låse sektionen. Samme
  // fælde som ADV-204, og grunden til at hooken findes.
  const { stamdata, profilStatus } = useStamdataPerson();

  // ADV-356: en firma- eller revisor-session har ingen person, så profil-tjekket slår altid til for
  // den og ville skrive "din profil er endnu ikke klar". Menupunktet er skjult for sådan en session
  // (useNavbarUserMenu), men et bogmærke går uden om det. Rækkefølgen mellem de to beskeder
  // afgøres og testes i getPersonligSideAfvisning.
  const afvisning = getPersonligSideAfvisning({
    userInfo: loaderdata.userInfo,
    profilStatus,
  });

  return (
    <div className="container-xxl mt-3 mb-7">
      <div className="card col-10">
        <div className="card-header">
          <h1 className="display-2 d-flex align-items-center justify-content-between">
            <span>Mine oplysninger</span>
            <span className="text-muted">
              {loaderdata.userInfo?.navn ?? "Ingen brugerinfo"}
            </span>
          </h1>
        </div>
        <div className="card-body p-0">
          {/* Findes profilen ikke i portalen endnu (ADV-288), er der ingen oplysninger at vise
              eller ændre. Accordionen ville stå med tomme felter — og for to af sektionerne med
              "Kunne ikke hente dine oplysninger. Prøv at genindlæse siden", som er den forkerte
              besked: forespørgslen lykkedes, og profilen bliver ikke til af at hente siden igen.
              Én ærlig besked i stedet.

              Kun "ikkeKlar" spærrer. "ukendt" — forespørgslen har endnu ikke svaret, eller den
              fejlede — falder igennem til sektionerne, og det er med vilje: de har loader-data som
              initialData og står altså ikke tomme imens, og for en fejlet forespørgsel er deres
              egen røde besked om at genindlæse siden den rigtige, hvor "profilen er ikke klar"
              ville være direkte misvisende. */}
          {afvisning === "ikkePersonligSession" ? (
            <div className="p-4">
              <IkkePersonligSessionBesked
                identityType={loaderdata.userInfo.identityType}
                navn={loaderdata.userInfo.navn}
                konsekvens="Dine oplysninger kan kun vises"
              />
            </div>
          ) : afvisning === "profilIkkeKlar" ? (
            <div className="p-4">
              <ProfilIkkeKlarBesked konsekvens="dine oplysninger kan ikke vises her" />
            </div>
          ) : (
            <AccordionRoot>
              <AccountBasis stamdata={stamdata} />
              <AccountInteresser stamdata={stamdata} />
              {/* <AccountNytJob stamdata={stamdata} /> */}
              <AccountDelegation stamdata={stamdata} />
            </AccordionRoot>
          )}

          {/* <pre>{JSON.stringify(loaderdata, null, 2)}</pre> */}
        </div>
      </div>
    </div>
  );
}
